// | Translated support for Restaumatic.FormField.
import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dVault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const identity = x => x;
const TranslatedFormField = x => x;
const hasFieldIdTranslatedFormF = dictHasFieldId => dictHasFieldId;
const hasErrorsTranslatedFormFi = dictHasErrors => dictHasErrors;
const toTranslatedString = dict => dict.toTranslatedString;
const fromTranslatedString = dict => dict.fromTranslatedString;
const editingLocaleKey = /* #__PURE__ */ Data$dVault.newKey();
const editingLocale = /* #__PURE__ */ Data$dVault.singleton(editingLocaleKey);
const defaultLocaleKey = /* #__PURE__ */ Data$dVault.newKey();
const translatedTextInput = dictIsRefLike => dictHasContext => dictAsTranslatedString => field => {
  const locales = Specular$dFRP$dBase.bindDynamic.bind(dictHasContext.getContext(field))(context => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => (
    {editingLocale: v, defaultLocale: v1}
  ))(Restaumatic$dForm$dInternal.unFinalFromContext(Restaumatic$dForm$dInternal.hasContextContext)(editingLocaleKey)(context)))(Restaumatic$dForm$dInternal.unFinalFromContext(Restaumatic$dForm$dInternal.hasContextContext)(defaultLocaleKey)(context)));
  return {
    displayedValue: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => {
      const $0 = (() => {
        if (v1.editingLocale.tag === "Just") {
          if (v.tag === "Just") { return Data$dMap$dInternal.lookup(Restaumatic$dLocales.ordLocale)(v1.editingLocale._1)(dictAsTranslatedString.toTranslatedString(v._1)); }
          return Data$dMaybe.Nothing;
        }
        if (v1.editingLocale.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })();
      if ($0.tag === "Nothing") { return ""; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    })(dictIsRefLike.readRefLike(field)))(locales),
    onChange: str => {
      const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(locales);
      return () => {
        const v = $0();
        return for_(v.editingLocale)(locale => {
          const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(dictIsRefLike.readRefLike(field));
          return () => {
            const currentValue = $1();
            return dictIsRefLike.writeRefLike(field)(Restaumatic$dForm$dInternal.$TypedValue(
              "Valid",
              {
                value: dictAsTranslatedString.fromTranslatedString(Data$dMap$dInternal.filterWithKey(Restaumatic$dLocales.ordLocale)(v$1 => v1 => v1 !== "")(Data$dMap$dInternal.insert(Restaumatic$dLocales.ordLocale)(locale)(str)((() => {
                  if (currentValue.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
                  if (currentValue.tag === "Just") { return dictAsTranslatedString.toTranslatedString(currentValue._1); }
                  $runtime.fail();
                })()))),
                editValue: Data$dMaybe.Nothing
              }
            ))();
          };
        })();
      };
    },
    onTouch: dictIsRefLike.touchRefLike(field),
    placeholder: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => {
      const $0 = v.tag === "Just" ? Data$dMaybe.$Maybe("Just", dictAsTranslatedString.toTranslatedString(v._1)) : Data$dMaybe.Nothing;
      if ($0.tag === "Just") {
        const $1 = (() => {
          if (v1.defaultLocale.tag === "Just") {
            const $1 = Data$dTuple.Tuple(v1.defaultLocale._1);
            const $2 = Data$dMap$dInternal.lookup(Restaumatic$dLocales.ordLocale)(v1.defaultLocale._1)($0._1);
            if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", $1($2._1)); }
            return Data$dMaybe.Nothing;
          }
          if (v1.defaultLocale.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        })();
        const $2 = Data$dMap$dInternal.findMin($0._1);
        const $3 = (() => {
          if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple($2._1.key, $2._1.value)); }
          if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        })();
        if ($1.tag === "Nothing") {
          if ($3.tag === "Just") {
            if ($3._1._2 !== "") {
              return "[" + (() => {
                if ($3._1._1.tag === "PL") { return "pl"; }
                if ($3._1._1.tag === "EN") { return "en"; }
                if ($3._1._1.tag === "EN_GB") { return "en-GB"; }
                if ($3._1._1.tag === "RO") { return "ro"; }
                if ($3._1._1.tag === "RU") { return "ru"; }
                if ($3._1._1.tag === "CS") { return "cs"; }
                if ($3._1._1.tag === "SK") { return "sk"; }
                if ($3._1._1.tag === "HR") { return "hr"; }
                if ($3._1._1.tag === "DE") { return "de"; }
                if ($3._1._1.tag === "NL") { return "nl"; }
                if ($3._1._1.tag === "ES") { return "es"; }
                if ($3._1._1.tag === "IT") { return "it"; }
                if ($3._1._1.tag === "UK") { return "uk"; }
                if ($3._1._1.tag === "SL") { return "sl"; }
                if ($3._1._1.tag === "PT_BR") { return "pt-BR"; }
                $runtime.fail();
              })() + "] " + $3._1._2;
            }
            return "";
          }
          if ($3.tag === "Nothing") { return ""; }
          $runtime.fail();
        }
        if ($1.tag === "Just") {
          if ($1._1._2 !== "") {
            return "[" + (() => {
              if ($1._1._1.tag === "PL") { return "pl"; }
              if ($1._1._1.tag === "EN") { return "en"; }
              if ($1._1._1.tag === "EN_GB") { return "en-GB"; }
              if ($1._1._1.tag === "RO") { return "ro"; }
              if ($1._1._1.tag === "RU") { return "ru"; }
              if ($1._1._1.tag === "CS") { return "cs"; }
              if ($1._1._1.tag === "SK") { return "sk"; }
              if ($1._1._1.tag === "HR") { return "hr"; }
              if ($1._1._1.tag === "DE") { return "de"; }
              if ($1._1._1.tag === "NL") { return "nl"; }
              if ($1._1._1.tag === "ES") { return "es"; }
              if ($1._1._1.tag === "IT") { return "it"; }
              if ($1._1._1.tag === "UK") { return "uk"; }
              if ($1._1._1.tag === "SL") { return "sl"; }
              if ($1._1._1.tag === "PT_BR") { return "pt-BR"; }
              $runtime.fail();
            })() + "] " + $1._1._2;
          }
          return "";
        }
        if ($1.tag === "Nothing") { return ""; }
        $runtime.fail();
      }
      if ($0.tag === "Nothing") { return ""; }
      $runtime.fail();
    })(dictIsRefLike.readRefLike(field)))(locales)
  };
};
const isTextFieldTranslatedForm = dictIsRefLike => dictHasContext => dictAsTranslatedString => (
  {textInput: v => translatedTextInput(dictIsRefLike)(dictHasContext)(dictAsTranslatedString)(v)}
);
const validateNonEmptyInDefaultLocale = v => {
  const $0 = [
    Restaumatic$dForm$dFinal.applyFinal.apply(Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") {
        return Data$dEither.$Either(
          "Right",
          (() => {
            const $0 = m._1;
            return v2 => {
              if (v2.tag === "Just") {
                if (Restaumatic$dI18n$dTypes.getLocalization(v2._1)($0) === "") {
                  return [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
                }
                return [];
              }
              if (v2.tag === "Nothing") { return []; }
              $runtime.fail();
            };
          })()
        );
      }
      $runtime.fail();
    })(Restaumatic$dForm$dFormField.readValueF(v)))(Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(Restaumatic$dForm$dInternal.unFinalFromContext(Restaumatic$dForm$dFormField.hasContextFormField$p)(defaultLocaleKey)(v))))
  ];
  return v.validations._2(_old => $0);
};
const defaultLocale = /* #__PURE__ */ Data$dVault.singleton(defaultLocaleKey);
const asTranslatedStringTS = {toTranslatedString: identity, fromTranslatedString: identity};
const asTranslatedStringMaybeTS = {
  toTranslatedString: v2 => {
    if (v2.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  },
  fromTranslatedString: v => {
    if (v.tag === "Leaf") { return Data$dMaybe.Nothing; }
    return Data$dMaybe.$Maybe("Just", v);
  }
};
export {
  TranslatedFormField,
  asTranslatedStringMaybeTS,
  asTranslatedStringTS,
  defaultLocale,
  defaultLocaleKey,
  editingLocale,
  editingLocaleKey,
  for_,
  fromTranslatedString,
  hasErrorsTranslatedFormFi,
  hasFieldIdTranslatedFormF,
  identity,
  isTextFieldTranslatedForm,
  toTranslatedString,
  translatedTextInput,
  validateNonEmptyInDefaultLocale
};
